import React, { useEffect } from 'react';

const Commands = () => {
  useEffect(() => {
    const revealOnScroll = () => {
      const elements = document.querySelectorAll('.fade-in');
      elements.forEach(element => {
        const elementTop = element.getBoundingClientRect().top;
        const elementVisible = 100;
        if (elementTop < window.innerHeight - elementVisible) {
          element.classList.add('visible');
        }
      });
    };

    window.addEventListener('scroll', revealOnScroll);
    revealOnScroll();

    return () => window.removeEventListener('scroll', revealOnScroll);
  }, []);

  const commands = [
    { name: '/help', desc: 'Display all available commands and their usage' },
    { name: '/kick', desc: 'Kick a member from your server with optional reason' },
    { name: '/ban', desc: 'Ban a member from your server permanently' },
    { name: '/warn', desc: 'Issue a warning to a server member' },
    { name: '/poll', desc: 'Create interactive polls for your community' },
    { name: '/music', desc: 'Play music in voice channels' },
    { name: '/welcome', desc: 'Set up custom welcome messages' },
    { name: '/stats', desc: 'View detailed server statistics' }
  ];

  return (
    <section className="commands" id="commands">
      <div className="commands-container">
        <div className="section-title fade-in">
          <h2>Popular Commands</h2>
          <p>Get started with these essential commands</p>
        </div>
        <div className="commands-grid">
          {commands.map((command, index) => (
            <div className="command-card fade-in" key={index}>
              <div className="command-name">{command.name}</div>
              <div className="command-desc">{command.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Commands;
